import React, { useRef, useEffect, useState, useCallback } from 'react';
import AnimateSlider from 'jd-library/AnimateSlider';
import withRipple from 'jd-library/withRipple';
import { useSwipeable } from 'react-swipeable'
import {onFileSelUpload} from './productImageUtils';
import FileSelector from './FileSelector';
import './edit-image-options.scss';

const optionsObj = {
	changeImage: {
		text: 'Change Image',
		icon: 'icon-myImages',
		value: 'changeImage'
	},
	viewImage: {
		text: 'View Image',
		icon: 'icon-show',
		value: 'viewImage'
	},
	deleteImage: {
		text: 'Delete Image',
		icon: 'icon-trash',
		value: 'deleteImage'
	}
};

const getOptionsMarkup = (props, onEditOptionClick) => {
	let listOptions = props.listOptions || [
		'changeImage',
		'viewImage',
		'deleteImage'
	];
	const optionsMarkup = [];
	listOptions.map(cur => {
		const curOption = optionsObj[cur];
		optionsMarkup.push(<EditOptionRipple {...curOption} onClick={onEditOptionClick} />);
	});
	return optionsMarkup;
};


const EditImageOptions = props => {
	const sliderRef = useRef(null);
	const innerSliderRef = useRef(null);
	const fileSelector = React.useRef(null);
	const [showOverlay, updateOverlay] = useState(false);
	const swipeHandlers = useSwipeable({
		onSwiped: (eventData) => {
			if(eventData.dir === 'Down'){
				const newY = eventData.absY;
				if(newY > 85){
					closeOptions();
					// innerSliderRef.current.style.transform = '';
				} else {
					innerSliderRef.current.style.transform = 'translate3d(0px, 0px, 0px)'
				}
			}
		},
		onSwiping: (eventData) => {
			if(eventData.dir === 'Down'){
				const newY = eventData.absY;
				if(newY > 80){
					closeOptions();
					// innerSliderRef.current.style.transform = ''
				} else {
					innerSliderRef.current.style.transform = `translate3d(0px, ${newY}px, 0px)`
				}
			} else if(eventData.dir === 'Up'){
				const newY = Math.max(-eventData.absY , 0)
				innerSliderRef.current.style.transform = `translate3d(0px, ${newY}px, 0px)`
			}
		},
		preventDefaultTouchmoveEvent: true,
		trackTouch: true
	})
	useEffect(() => {
		innerSliderRef.current = sliderRef.current.sliderContentRef.current;
		sliderRef.current.toggle(true);
		updateOverlay(true);
		return () => {
			sliderRef.current.toggle(false);
		};
	}, []);
	const onEditOptionClick = (value) => {
		switch(value){
			case 'changeImage':
				console.log(value);
				fileSelector.current.triggerClick();
			break;
			case 'viewImage':
				props.toggleEditImageOptions(null);
				setTimeout(() => {
					props.toggleViewImageSlider(true, props.productId, parseInt(props.imgIndex));
				}, 100);
			break;
			case 'deleteImage':
				const finalImageArr = [...props.imageUrlArr];
				finalImageArr.splice(props.imgIndex, 1);
				closeOptions();
				props.deleteProductImage({
					productId: props.productId,
					supplierId: props.supplierId,
					imageUrlArr: finalImageArr
				});
			break;
		}
	}
	const closeOptions = useCallback((e) => {
		e && e.stopPropagation();
		sliderRef.current && sliderRef.current.toggle(false);
		updateOverlay(false);
		setTimeout(() => {
			props.toggleEditImageOptions(null);
		}, 350);
	}, [])
	return (
		<div {...swipeHandlers}>
			<AnimateSlider
				ref={sliderRef}
				width={'100%'}
				slideDirection={'bottom'}
				showOverlay={false}
				className={'edit-image-options-menu'}
			>
				{getOptionsMarkup(props, onEditOptionClick)}
				<CrossIcon 
					{...props} 
					onClick={closeOptions}
				/>
				<FileSelector 
					onChange={(e) => {
						onFileSelUpload(e, {
							...props,
							forChangeImage: true
						}, props.imgIndex);
						setTimeout(() => {
							props.toggleEditImageOptions(null);
						}, 0);
					}}
					ref={fileSelector}
				/>
			</AnimateSlider>
			<div
				className={`edit-options-overlay ${showOverlay ? 'visible' : ''}`}
				onClick={closeOptions}
				// onTouchMove={closeOptions}
			></div>
		</div>
	);
};

const CrossIcon = withRipple(props => {
	return (
		<div
			className={`close-option ${props.rippleClass}`}
			onClick={props.onClick}
			{...props.rippleHandler}
		>
			<i className='icon-HDRcross' />
			{props.renderRipple()}
		</div>
	);
});

const EditOption = props => {
	
	return (
		<div
			className={`edit-option ${props.rippleClass}`}
			onClick={() => props.onClick(props.value)}
			{...props.rippleHandler}
		>
			<i className={`${props.icon} edit-option-icon`} />
			<span className={`edit-option-text`}>{props.text}</span>
			{props.renderRipple()}
		</div>
	);
};
const EditOptionRipple = withRipple(EditOption);

export default EditImageOptions;
